/**
 * @file index.ts
 * @author markJia(markjia@tencent.com)
 */
import { TabItem } from './TabItem';
import { Tabs } from './Tabs';
var GlueTabs = Object.assign(Tabs, {
  Item: TabItem
});
export { GlueTabs as Tabs, TabItem };